<template>

    <section class="c-issues">
        <h3>Lista problemów pacjenta</h3>
        <div class="c-issues__inner">
            <ol
                :style="{ counterReset: 'prokrastynacja ' + startNumber }"
                v-if="issues.data.length"
                class="c-issues__list">
                <form-list-item
                    v-for=" (issue, index) in issues.data"
                    :key="index"
                    class="c-issues__item"
                    :to="{ name: 'PatientVisits', params: { id: patient.id },  query: { issue_id: issue.id }}"
                    hide-delete>
                    {{ issue.name }}
                </form-list-item>
            </ol>
            <p
                class="c-issues__empty"
                v-else>
                Brak problemów
            </p>
            <v-loader :loading="isFetching"></v-loader>
        </div>

        <v-pagination
            v-model="issues.last_page"
            name="issues_page">
        </v-pagination>
    </section>

</template>


<script>

import {mapGetters} from 'vuex'
import {FormListItem} from 'Components/Form'
import VPagination from 'Components/VPagination'
import VLoader from 'Components/VLoader'

export default {

    name: 'PatientIssues',

    data() {
        return {
            isFetching: false,
            startNumber: 0
        }
    },

    computed: {
        ...mapGetters('patient', ['patient', 'issues']),
        compStartNumber() {
            const per_page = this.issues.per_page || 0
            return per_page * (this.currentPage - 1)
        },
        currentPage() {
            return this.$route.query.issues_page
        }
    },

    watch: {
        '$route.query.issues_page'() {
            this.isFetching = true
            this.$store.dispatch('patient/FETCH_ISSUES', {
                id: this.patient.id,
                page: this.currentPage,
            }).then(() => {
                this.startNumber = this.compStartNumber
                this.isFetching = false
            }).catch(() => {
                this.isFetching = false
            })
        }
    },

    mounted() {
        this.startNumber = this.compStartNumber
    },

    components: {
        FormListItem,
        VPagination,
        VLoader
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-issues {
    &__inner {
        position: relative;
    }
    &__list {
        counter-reset: prokrastynacja;
        margin-top: 20px;
        width: 100%;
    }
    &__empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 1.2rem;
        margin: 2rem 0;
        width: 100%;
        text-align: center;
    }
}

</style>
